export default "__VITE_ASSET__DYZ7yfq3__"